import { useGetCarBrandsQuery } from '@/api/carBrands'
import NameValue from '@/types/NameValue'
import React from 'react'
import FilterableSelect from '@/components/inputs/FilterableSelect/FilterableSelect'
import { useTranslation } from 'react-i18next'

type Props = {
  onClick: (value: number) => void
  selected: number | undefined
}

const CarBrands = (props: Props) => {
  const { data, isLoading } = useGetCarBrandsQuery()
  const { t } = useTranslation('shop')

  const mappedData: NameValue[] = data?.map((brand) => {
    return {
      name: brand.name,
      value: brand.id
    }
  }) || []

  const onClickFilterableSelect = (value: string | null) => {
    let newValue
    if (value === null)
      newValue = undefined
    else
      newValue = Number(value)

    props.onClick(newValue as number)
  }

  return (
    <FilterableSelect
      name="carBrand"
      options={mappedData}
      value={props.selected ? props.selected.toString() : null}
      onChange={onClickFilterableSelect}
      loading={isLoading}
      placeholder={t('brand') || ''}
    />
  )
}

export default CarBrands